<template>
  <div 
    :class="[
        'instructions-menu-item', 
        'instr-panel-toggle',
        { selected: selected }
    ]"
    @click.stop="$emit('show')"
  >
    <div class="button-label --uppercase">
      <span class="desktop-hide" v-if="appliedInstructions.length">{{ appliedInstructions.length }}</span>
      <slot></slot>
    </div>
    <ul class="instruction-list">
      <li 
        v-for="instructionAddress in appliedInstructions"
        :key="instructionAddress"
      >
        {{ $t(instructionAddress) }}
      </li>
    </ul>
    <div class="direction-hint --uppercase">
      {{ selected ? doneString : changeString }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selected: Boolean,
    appliedInstructions: Array
  },

  data: function() {
    return {
      changeString: '>> ' + this.$t('ui.change'),
      doneString: '<< ' + this.$t('ui.done')
    };
  }
}
</script>

<style scoped>
.instr-panel-toggle {
  box-sizing: border-box;
  border: solid 1px rgba(0,0,0,0);
}

.desktop-hide {
  display: none !important;
}

@media only screen and (max-width: 767px) {
  .desktop-hide {
    display: unset !important;
  }

  .direction-hint {
    display: none;
  }

  .button-label {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow-x: hidden;
  }

  .instruction-list {
    display: none;
  }
}
</style>
